import React from "react";
import Navbar from "../Navbar/Navbar";
import "./Home.css";
import Profile from "./Profile/Profile";

function Home() {
  return (
    <div className="home-container" id="#home">
      <Profile />


      {/* <Footer /> */}
    </div>
  );
}

export default Home;
